import {Component, Inject, OnDestroy, OnInit} from "@angular/core";
import RegroupementPlatDTO from "../../../../core/dtos/conditionnement/regroupement-plat-d-t-o";
import {RegroupementPlatML} from "../../../../core/dtos/conditionnement/regroupement-plat-ml";
import {
  RegroupementPlatService
} from "../../../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {Subscription} from "rxjs";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {UnitesDeProductionService} from "../../../../core/services/entities/unites-de-production.service";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {Router} from "@angular/router";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";
@Component({
    selector: 'yo-regroupement-plat-dialog-fiche-technique',
    templateUrl: './regroupement-plat-dialog-fiche-technique.component.html',
    styleUrls: ['./regroupement-plat-dialog-fiche-technique.component.scss'],
    standalone: false
})

export class RegroupementPlatDialogFicheTechniqueComponent implements OnInit, OnDestroy{

  private subSave: Subscription;
  selectedSite: number;
  sitesList: any[];
  private subUnitesDeProduction: Subscription;
  unitesDeProductionList: any[];
  selectedUdp: any[] = [];

  constructor(@Inject('dynamicData') public regroupementPlat: RegroupementPlatDTO,
              private regroupementSvc: RegroupementPlatService,
              private utilSvc: UtilsService,
              private udpSvc: UnitesDeProductionService,
              private authSvc: Auth2Service,
              private toastSvc: ToastService,
              private router: Router) {
  }

  ngOnInit() {
    this.initSites()
    this.initUnitesDeProductionLocauxSubscription()
  }

  ngOnDestroy() {
    this.utilSvc.unsubscribe(this.subSave);
    this.utilSvc.unsubscribe(this.subUnitesDeProduction)
  }

  saveRegroupementPlat() {
    const regroupementML = new RegroupementPlatML();
    regroupementML.id = this.regroupementPlat.id;
    regroupementML.idSite = this.selectedSite;
    regroupementML.libelle = this.regroupementPlat.libelle;
    regroupementML.idsUniteDeProduction = this.selectedUdp;
    this.subSave = this.regroupementSvc.save(regroupementML).subscribe((res) => {
      if (res.one) {
        if (res.one.updateError) {
          this.regroupementSvc.announceErreurParametrage(res.one.erreurs)
        } else {
          this.regroupementPlat = res.one.regroupementPlat;
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde du regroupement de plat réalisée avec succès`);
          this.router.navigate([`/gestion-conditionnements/regroupement-plat-plc/settings/${this.regroupementPlat.id}`])
        }
      }
    })
  }

  canEdit() {
    return(this.regroupementPlat != null && (this.regroupementPlat.id === 0) || this.authSvc.isSiteLocal(this.regroupementPlat?.site?.id));
  }

  private initSites = (): void => {
    this.sitesList = this.authSvc.utilisateur.siteListLocaux;
    if (this.regroupementPlat.id !== 0)
      this.selectedSite = this.regroupementPlat.site.id
  };

  initUnitesDeProductionLocauxSubscription = (): void => {
    if (this.regroupementPlat.id !== 0)
      this.selectedUdp = this.regroupementPlat.uniteDeProduction.map(udp => udp.id);
    this.subUnitesDeProduction = this.udpSvc.findUnitesProductionByFilters({ enabled: true, onlyLocalSites: true })
      .subscribe(response => {
        if (!this.utilSvc.isResponseSupplierError(response)) {
          this.unitesDeProductionList = response.resultList;
        }
      });
  };

  updateUdpList($event: any) {
    this.selectedUdp = $event
  }

  updateSelectedSite($event: any) {
    this.selectedSite = $event
  }

  canSave() {
    return this.regroupementPlat != null && this.canEdit() && this.selectedSite != null && this.selectedUdp.length > 0;
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
